import {Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';

import { AviationEvent } from '../../shared/models/aviation-event.model';
import { State } from '../../shared/state-view/state.model';
import { SatPopover } from '@ncstate/sat-popover';
import { SearchQuery } from '../models/search-query.model';
import { UserService } from '../../shared/user/user.service';
import { UserInfo } from '../../shared/models/user-info.model';
import { PageEvent } from '@angular/material';


@Component({
  selector: 'app-event-results-listing',
  templateUrl: './event-results-listing.component.html',
  styleUrls: ['./event-results-listing.component.scss']
})
export class EventResultsListingComponent implements OnInit {
  @Input() query: SearchQuery;
  @Input() aviationEvents: Array<AviationEvent>;
  @Input() state: State = State.Empty;
  @Input() activeAviationEvent: AviationEvent;
  @Input() errorMessage: string;
  @Input() eventPageIndex = 0;
  @Input() eventPageSize = 25;
  @Input() totalAviationEvents = 0;
  @Output() eventMouseEnter = new EventEmitter<AviationEvent>();
  @Output() eventMouseLeave = new EventEmitter<AviationEvent>();
  @Output() filtersChanged = new EventEmitter<SearchQuery>();
  @Output() filtersDateChanged = new EventEmitter<SearchQuery>();
  @Output() showAirportsToggleChanged = new EventEmitter<void>();
  @Output() eventPageChanged = new EventEmitter<PageEvent>();
  private _userInfo: UserInfo;

  showAirports = false;

  @ViewChild('aviationEventListEl') aviationEventListEl: ElementRef;
  @ViewChildren('aviationEventEl', { read: ElementRef }) aviationEventEls: QueryList<ElementRef>;
  // @ViewChild('airportFilters') eventFilters: EventFilterListComponent;
  @ViewChild('eventFiltersPopover') eventFiltersPopover: SatPopover;

  constructor(private _userService: UserService) { }

  async ngOnInit() {
    this._userInfo = this._userService.userInfo.getValue();
    this._userService.userInfo.subscribe(async u => {
      // Update userInfo
      this._userInfo = u;

      // Set state to loaded
      this.showAirports = await this._userService.getShowAirportsFlag();
      this.state = State.Content;
    });
  }

  onEventHover(aviationEvent: AviationEvent, hover: boolean) {
    if (hover) {
      this.eventMouseEnter.emit(aviationEvent);
    } else {
      this.eventMouseLeave.emit(aviationEvent);
    }
  }

  onFiltersChanged() {
    this.filtersChanged.emit(this.query);
  }

  onFiltersChangedDate() {
    this.filtersDateChanged.emit(this.query);
  }

  /**
   * Returns a jQuery element container for the given airport.
   */
  getEventEl(aviationEvent: AviationEvent) {
    const i = this.aviationEvents.indexOf(aviationEvent);
    if (i < 0) {
      return null;
    }
    const el = this.aviationEventEls.toArray()[i];
    // @ts-ignore
    return $(el.nativeElement);
  }

  /**
   * Scrolls the airports list to the specified airport, marking it as selected.
   */
  public scrollToEvent(aviationEvent: AviationEvent) {
    if (!this.aviationEventListEl) {
      return;
    }
    // @ts-ignore
    const $containerEl = $(this.aviationEventListEl.nativeElement);
    const $el = this.getEventEl(aviationEvent);
    if (!$el) {
      return;
    }
    const position = $el[0].offsetTop;
    $containerEl.stop(true);
    $containerEl.animate({ scrollTop: position }, 500);
  }

  async onShowAirportsToggleChanged() {
    await this._userService.saveShowAirportsFlag(this.showAirports);
    this.showAirportsToggleChanged.emit();
  }

  onEventPageChanged(e: PageEvent) {
    this.eventPageChanged.emit(e);
    if (!this.aviationEventListEl) {
      return;
    }
    // @ts-ignore
    const $containerEl = $(this.aviationEventListEl.nativeElement);
    $containerEl.stop(true);
    $containerEl.animate({ scrollTop: 0 }, 500);
  }
}
